import { BoxWrapper, Button } from 'components/Base';
import React, { useState } from 'react';
import RiskDescriptionModal from 'components/RiskDescription/RiskDescriptionModal';
import { connect } from 'react-redux';
import selectors from 'store/selectors';
import { getRiskDescriptionMorningStar } from 'utils';
import MorningstarRiskToleranceChart from './MorningstarRiskToleranceChart';
interface Props {
  userResponses?: any;
  caseInfo?: any;
}

const MorningstarRiskTolerance: React.FC<Props> = ({
  userResponses,
  caseInfo
}) => {
  const [isRiskModalOpen, setIsRiskModalOpen] = useState(false);

  return (
    <>
      <BoxWrapper
        title="Risk Tolerance"
        subTitle="Risk Tolerance Group is calculated based on the results from the ATRQ"
        style={{
          display: 'flex',
          height: '100%'
        }}
        headerChildren={
          <Button
            variant="contained"
            color="secondary"
            type="button"
            onClick={() => setIsRiskModalOpen(true)}
            disabled={!userResponses?.[0]?.raw_data?.score?.calculatedRiskGroup}
          >
            View Risk Group
          </Button>
        }
      >
        <MorningstarRiskToleranceChart showSuitability={true} showRisk={true} />
      </BoxWrapper>
      <RiskDescriptionModal
        score={5}
        isOpen={isRiskModalOpen}
        setIsOpen={setIsRiskModalOpen}
        riskDescription={getRiskDescriptionMorningStar(
          userResponses?.[0]?.raw_data?.score,
          caseInfo
        )}
      />
    </>
  );
};

export default connect((state: any) => ({
  userResponses: selectors.questionnareSelectors.getUserResponses(state),
  caseInfo: selectors.caseSelectors.case(state)
}))(MorningstarRiskTolerance);
